<script>
  export default {
    props: ['campaign']
  }
</script>

<template>
  <div class="digital-160x600-preview">
    <div class="digital-160x600-preview__logo-image-wrapper" :style="{ backgroundColor: campaign.advertiser.backgroundColor }">
      <img :src="campaign.logoImage.url" alt="" class="digital-160x600-preview__logo-image" />
    </div>
    <div>
      <div class="embed-responsive embed-responsive-4by3">
        <div class="embed-responsive-item">
          <img :src="campaign.campaignImages[0].image.url" alt="" class="w-100 h-100" />
        </div>
      </div>
      <div class="embed-responsive embed-responsive-4by3">
        <div class="embed-responsive-item">
          <img :src="campaign.campaignImages[1].image.url" alt="" class="w-100 h-100" />
        </div>
      </div>
    </div>
    <div class="text-center mt-2">
      <p class="digital-160x600-preview__headline px-2">{{ campaign.digitalHeadline }}</p>
      <div>
        <img :src="campaign.contactImage.url" alt="" class="rounded-circle digital-160x600-preview__contact-image mb-3" />
        <p class="mb-0 digital-160x600-preview__agent">{{ campaign.agentName }}</p>
        <p class="digital-160x600-preview__phone font-weight-bold mb-0">{{ campaign.agentPhoneDisplay ? campaign.agentPhone : '' }}</p>
      </div>
      <button class="digital-160x600-preview__button font-size-16 mt-2" :style="{ backgroundColor: campaign.callToActionBackgroundColor, color: campaign.callToActionTextColor }">{{ campaign.callToActionType.description }}</button>
    </div>
  </div>
</template>